import { createContext, useContext } from 'react'

export type RadioGroupVariant = 'default' | 'button'

// `RadioGroup` tells its `Radio` children how to render so a call site
// switches a whole group between the dot and the segmented-button look with
// one prop instead of swapping every child.
export const RadioGroupVariantContext =
  createContext<RadioGroupVariant>('default')

export const useRadioGroupVariant = (): RadioGroupVariant =>
  useContext(RadioGroupVariantContext)
